import FlowValidationService, {
    FLOW_VALIDATION_ERROR,
    FLOW_VALIDATION_WARN,
    FLOW_GENERIC_VALIDATION,
    FLOW_FIELD_VALIDATION,
    FLOW_UNDERWRITING_ISSUE
} from './FlowValidationServiceNg';

angular.module('gw-digitalapps-flowvalidationservice-angular', ['edge.platform.util'])
    .factory('FlowValidationService', FlowValidationService)
    .constant('FLOW_VALIDATION_ERROR', FLOW_VALIDATION_ERROR)
    .constant('FLOW_VALIDATION_WARN', FLOW_VALIDATION_WARN)
    .constant('FLOW_GENERIC_VALIDATION', FLOW_GENERIC_VALIDATION)
    .constant('FLOW_FIELD_VALIDATION', FLOW_FIELD_VALIDATION)
    .constant('FLOW_UNDERWRITING_ISSUE', FLOW_UNDERWRITING_ISSUE);